import escapeRegexSpecialCharacters from 'utils/functions/escapeRegexSpecialCharacters';
import { filterByCountry } from './AllMovements.helpers';

export const analyticsViewPayload = {
  pagename: 'areaprivata:gestione_conto:ultimi_movimenti',
};

export enum AllMovementsSection {
  all = 0, // getMovements
  bets = 3, // GET SCOMMESSE getBets
  sportBets = 15, // transactions Scommesse Sportive
  poker = 7, // getMovements
  cardGames = 10, // getMovements
  casinoAndSlots = 11, // getMovements
  quickGames = 12, // getMovements
  lotteries = 9, // GET LIST GIOCATE GNTN getGntnPlayList
  scratchAndWin = 6, // GET GIOCATE LIT getLitPlayList
  lotto = 14, // getMovements
  bingo = 8, // getMovements
  recharges = 1, // getMovements
  widrawals = 2, // getMovements
  bookedOperations = 16, // GET OPERAZIONE PRENOTATE getBookingOperations
  lotteryItaly = 18, // getBets
}

export const allMovementsSectionLabelById = {
  [AllMovementsSection.all]: 'AllMovementsSection.all',
  [AllMovementsSection.bets]: 'AllMovementsSection.bets',
  [AllMovementsSection.sportBets]: 'AllMovementsSection.sportBets',
  [AllMovementsSection.poker]: 'AllMovementsSection.poker',
  [AllMovementsSection.cardGames]: 'AllMovementsSection.cardGames',
  [AllMovementsSection.casinoAndSlots]: 'AllMovementsSection.casinoAndSlots',
  [AllMovementsSection.quickGames]: 'AllMovementsSection.quickGames',
  [AllMovementsSection.lotteries]: 'AllMovementsSection.lotteries',
  [AllMovementsSection.scratchAndWin]: 'AllMovementsSection.scratchAndWin',
  [AllMovementsSection.lotto]: 'AllMovementsSection.lotto',
  [AllMovementsSection.bingo]: 'AllMovementsSection.bingo',
  [AllMovementsSection.recharges]: 'AllMovementsSection.recharges',
  [AllMovementsSection.widrawals]: 'AllMovementsSection.widrawals',
  [AllMovementsSection.bookedOperations]:
    'AllMovementsSection.bookedOperations',
  [AllMovementsSection.lotteryItaly]: 'AllMovementsSection.lotteryItaly',
};

const listMovements = filterByCountry([
  AllMovementsSection.all,
  AllMovementsSection.poker,
  AllMovementsSection.bets,
  AllMovementsSection.casinoAndSlots,
  AllMovementsSection.recharges,
  AllMovementsSection.widrawals,
]);

// tabs displayed according to the insertion order.
export const TabListMovements: { label: string; optionId: number }[] =
  listMovements.map((optionId) => ({
    label: allMovementsSectionLabelById[optionId],
    optionId,
  }));

export const supportedTabsRegex = new RegExp(
  `^(?:${TabListMovements.map((tab) =>
    escapeRegexSpecialCharacters(tab.optionId + ''),
  ).join('|')})$`,
  'i',
);

// The initial value of 'selectType'.
export const defaultSelectMovementsOption = TabListMovements[0].optionId;

export const mapGetMovementsIds = {
  [AllMovementsSection.all]: 'all',
  [AllMovementsSection.poker]: 'poker',
  [AllMovementsSection.cardGames]: 'cardGames',
  [AllMovementsSection.casinoAndSlots]: 'casinoAndSlots',
  [AllMovementsSection.quickGames]: 'quickGames',
  [AllMovementsSection.lotto]: 'lotto',
  [AllMovementsSection.bingo]: 'bingo',
  [AllMovementsSection.recharges]: 'recharges',
  [AllMovementsSection.widrawals]: 'widrawals',
};

export const getMovementsIds: { [key: string]: any } = mapGetMovementsIds;
